import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './GlemtPassord.css';

function GlemtPassord() {
  const [epost, setEpost] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/glemt-passord`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ epost }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(data.message);
        setSubmitted(true);

        // For development: Vis reset-link hvis den finnes
        if (data.reset_link && process.env.NODE_ENV === 'development') {
          console.log('Reset-link (kun for utvikling):', data.reset_link);
          setMessage(
            `${data.message}\n\nFor testing: ${data.reset_link}`
          );
        }
      } else {
        setError(data.error || 'Noe gikk galt. Prøv igjen senere.');
      }
    } catch (err) {
      console.error('Feil ved glemt passord:', err);
      setError('Kunne ikke sende forespørsel. Sjekk internettforbindelsen din.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="glemt-passord-container">
      <div className="glemt-passord-box">
        <h1>Takstmann System</h1>
        <h2>Glemt passord</h2>

        {!submitted ? (
          <>
            <p className="info-text">
              Skriv inn e-postadressen din, så sender vi deg en link for å tilbakestille passordet.
            </p>

            {error && <div className="error-message">{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="epost">E-post</label>
                <input
                  type="email"
                  id="epost"
                  name="epost"
                  value={epost}
                  onChange={(e) => setEpost(e.target.value)}
                  required
                  autoComplete="email"
                  placeholder="din@epost.no"
                />
              </div>

              <button type="submit" disabled={loading} className="btn-primary">
                {loading ? 'Sender...' : 'Send reset-link'}
              </button>
            </form>

            <p className="back-link">
              <Link to="/login">Tilbake til innlogging</Link>
            </p>
          </>
        ) : (
          <>
            <div className="success-message">
              {message}
            </div>

            <p className="info-text" style={{ marginTop: '20px' }}>
              Sjekk innboksen din (og søppelpost-mappen). Linken er gyldig i 1 time.
            </p>

            <div style={{
              marginTop: '15px',
              padding: '12px',
              background: '#e3f2fd',
              borderRadius: '5px',
              fontSize: '14px',
              color: '#1565c0'
            }}>
              ⏱️ <strong>Merk:</strong> E-posten kan ta 1-5 minutter å komme fram.
              Hvis du ikke får den, sjekk søppelpost eller be om ny link (maks 5 forsøk per time).
            </div>

            <p className="back-link" style={{ marginTop: '30px' }}>
              <Link to="/login">Tilbake til innlogging</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default GlemtPassord;
